import { render, staticRenderFns } from "./Input.vue?vue&type=template&id=1c12d6f5&scoped=true"
import script from "./Input.vue?vue&type=script&lang=js"
export * from "./Input.vue?vue&type=script&lang=js"
import style0 from "./Input.vue?vue&type=style&index=0&id=1c12d6f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c12d6f5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Input: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Input.vue').default})
